import React from "react";

export type Action =
  | { type: "AUTHENTICATE"; payload: Player }
  | {
      type: "UPDATE_STATE";
      payload: State;
    }
  | { type: "RESET_STATE" }
  | { type: "TOGGLE_MODAL" }
  | { type: "TOGGLE_REQUEST_RESTART" };
// | {
//     type: "BACK_UP";
//   }
// | {
//     type: "SET_PLAYERS_NUMBER";
//     payload: number;
//   }
// | { type: "CREATE_PLAYERS"; payload: string[] }
// | { type: "ASSIGN_ROLES" }
// | { type: "CHECK_RULES" }
// | { type: "INIT_GOVERNMENT" }
// | { type: "NEXT_GOVERNMENT" }
// | { type: "PICK_CHANCELLOR"; payload: number }
// | { type: "HANDLE_VOTING"; payload: boolean }
// | { type: "PRESIDENT_REJECT_RULE"; payload: number }
// | { type: "CHANCELLOR_PASS_RULE"; payload: number }
// | { type: "VETO" }
// | { type: "ABILITY_DONE" }
// | { type: "ABILITY_HALF_DONE" }
// | { type: "SET_CHOSEN"; payload: number | null }
// | { type: "KILL_PLAYER"; payload: number }

export interface State {
  code: number;
  isStarted: boolean;
  hostId: string;
  player: Player;
  players: Player[];
  roundState: RoundState;
  playersNumber: number; // define how many player are in this game
  remainingPlayersNumber: number;
  fascistsIndexes: number[]; // index of players which are fascist
  hitlerIndex: number; // index of player which is hitler
  liberalRulesApproval: number; // count of liberal rules which are approved
  fascistRulesApproval: number; // count of fascist rules which are approved
  electionDeclined: number; // count of times which election has been declined
  drawRules: Rule[]; // the rules which we should pick from them to approve,
  discardRules: Rule[]; // the rules which we put aside,
  gameRules: GameRules; // rules of the game
  isPresidentIndex?: string;
  isChancellorIndex?: string;
  wasPresidentIndex?: string;
  wasChancellorIndex?: string;
  dashboardRules: Rule[];
  activeAbility: Abilities;
  chosenPlayerIndex?: string;
  returnPresidentIndex?: string;
  requestRestart: boolean;
  vetoState: VetoState;
}

export interface Dispatch {
  (action: Action): void;
}

export interface GameProviderProps {
  children: React.ReactNode;
}

export interface Player {
  id: string;
  clientId?: string;
  name: string;
  isLiberal?: boolean;
  isHitler?: boolean;
  isDead?: boolean;
  voteState: VoteState;
}

export interface GameRules {
  playersNumber: number[];
  fascistsNumber: number;
  hitlerKnowsFascists: boolean;
  abilities: Abilities[];
}

export enum Abilities {
  None,
  Search,
  NextPresident,
  Reveal,
  Kill,
}

export enum Rule {
  Liberal,
  Fascist,
}

export enum RoundState {
  WaitToStartAnotherRound,
  PickingChancellor,
  votingGovernment,
  PresidentRule,
  ChancellorRule,
  AbilityActive,
  GameFinished,
}

export enum VoteState {
  None,
  Agree,
  Decline,
}

export enum VetoState {
  None,
  Request,
  Agree,
  Decline,
}
